import shaarpLogo from "@/assets/shaarp-logo-main-light.svg";
import { ArrowLeft } from "lucide-react";
import { ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";

const WEBSITE_URL = import.meta.env.VITE_WEBSITE_BASE_URL;
const TERMS_URL = import.meta.env.VITE_TERMS_URL;
const PRIVACY_URL = import.meta.env.VITE_PRIVACY_URL;

export function AuthLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();

  return (
    <div
      className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10"
      style={{
        backgroundImage: "url(/auth-background.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex flex-col items-center gap-2">
          <img src={shaarpLogo} alt="Shaarp" className="w-3/4" />
          <a
            href={WEBSITE_URL}
            className="inline-flex items-center gap-1.5 self-start text-xs text-white/60 hover:text-white/80 transition-colors"
          >
            <ArrowLeft className="size-3" />
            {t("auth.backToWebsite")}
          </a>
        </div>
        {children}
      </div>
      <div className="text-center text-xs text-white/60">
        <p>
          <Trans
            i18nKey="auth.legalNoticeLine1"
            components={{
              termsLink: (
                <a
                  href={TERMS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-4 hover:text-white/80"
                />
              ),
            }}
          />
        </p>
        <p>
          <Trans
            i18nKey="auth.legalNoticeLine2"
            components={{
              privacyLink: (
                <a
                  href={PRIVACY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-4 hover:text-white/80"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
}
